import { multipart_headers } from '../Helper/helper';
import { routes } from '../config/api_routes';
import CryptoJS from 'crypto-js';
import config from "../config";

export const commonService = {
    removeTmpImage: (file) => window.axios.post(routes.removeTmpImageApi,{file}),

	encryptRequest(data){
		try {
			const jsonString = JSON.stringify(data);
			const salt = CryptoJS.lib.WordArray.random(8);
			const iv = CryptoJS.lib.WordArray.random(16);

			//Add Public Key For Ecryption
			let appKey = config.app_key;
			appKey = appKey.replace("base64:", "");

			console.log(appKey);
			
			const derivedKey = CryptoJS.PBKDF2(appKey, salt, { keySize: 256 / 32, iterations: 1000 });
			const encrypted = CryptoJS.AES.encrypt(jsonString, derivedKey, { iv: iv });
			const combined = salt.concat(iv).concat(encrypted.ciphertext);
			return CryptoJS.enc.Base64.stringify(combined);
		} catch (error) {
			console.error('Encryption error:', error);
			return null;
		}
	},
}